"use client";

import {
  SimpleGrid,
  TbLeaf,
  TbShield,
  TbTransfer,
  TbUsers,
  TbUserCheck,
  TbTrees,
  StatCard,
} from "@forestsync/ui";
import { useTranslations } from "next-intl";
import type { GlassroomStats } from "@/types/glassroom";

interface LedgerStatsProps {
  stats: GlassroomStats;
}

export function LedgerStats({ stats }: LedgerStatsProps) {
  const t = useTranslations();

  const statsData = [
    {
      title: t("glassroom.stats.co2TokensStored"),
      value: stats.totalTokens,
      icon: TbLeaf,
      color: "blue",
    },
    {
      title: t("glassroom.stats.projectDevelopers"),
      value: stats.totalProjectDevelopers,
      icon: TbUserCheck,
      color: "cyan",
    },
    {
      title: t("glassroom.stats.verifiedCarbonProjects"),
      value: stats.totalProjects,
      icon: TbTrees,
      color: "teal",
    },
    {
      title: t("glassroom.stats.totalTransactions"),
      value: stats.totalTransactions,
      icon: TbTransfer,
      color: "orange",
    },
    {
      title: t("glassroom.stats.registeredBeneficiaries"),
      value: stats.totalBeneficiaries,
      icon: TbUsers,
      color: "grape",
    },
    {
      title: t("glassroom.stats.tokensInInsurancePool"),
      value: stats.insurancePoolTokens,
      icon: TbShield,
      color: "green",
    },
  ];

  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 6 }} spacing="md">
      {statsData.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </SimpleGrid>
  );
}
